import React from 'react';
import { Flex, Button, Icon,Grid} from "antd-mobile";
import "./SubmitOk.scss";

class SubmitOk extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }

    };
    
    render(){
        const data = {
            icon: (<Icon type="check-circle" />)
          };
        return(
            <div className="body">
                <div className="body_top">
                    <div className="body_Icon">
                        <Icon type="check-circle" style={{height:'60px', width:'60px'}}/>
                        <p style={{color:'#333333',marginTop:'20%'}}>提交成功</p>
                    </div>
                </div>
                <div className="body_btn1">
                    <Button type="primary"
                         onClick={() => {
                            this.props.history.push('/induction_management');
                        }}
                    >确定
                    </Button>
                </div>
                <div className="body_btn2">
                    <Button
                        onClick={() => {
                            this.props.history.push('/home');
                        }}
                    >回到主页</Button>
                </div>
            </div>
        )
    }

}
export default SubmitOk